import {fadeIn, fadeOut} from "./Animate.ts";
import {createErrorNotification} from "../../portail/js/Notifications.ts";

export const $ = <T extends HTMLElement>(selecteur: string, scope: Document | Element = document): T | null => {
    return scope.querySelector<T>(selecteur);
}

export const $$ = <T extends HTMLElement>(selecteur: string, scope: Document | Element = document): NodeListOf<T> => {
    return scope.querySelectorAll<T>(selecteur);
}

export const empty = (element: Element | null) => {
    if (element) {
        element.innerHTML = '';
    }
}

export const hide = (element?: HTMLElement | null | undefined): void => {
    element?.classList?.add('d-none')
}
export const toggle = (element: HTMLElement | null | undefined, condition?: boolean): void => {
    if(!element) return
    if(condition !== undefined) {
        if (condition) element.classList.remove('d-none')
        else element?.classList?.add('d-none')
    } else {
        element.classList.toggle('d-none')
    }
}
export const toggleFadeInOut = (element: HTMLElement | null | undefined, condition?: boolean): void => {
    if(!element) return
    if(condition !== undefined) {
        if (condition) fadeIn(element)
        else fadeOut(element)
    } else {
        element.classList.contains('d-none') ? fadeIn(element) : fadeOut(element)
    }
}

export const show = (element?: HTMLElement | null | undefined): void => {
    element?.classList?.remove('d-none')
}

export const html_chargement_en_cours = (texte = "Chargement en cours", classes: string[] = ['blocs-chargement-spinner', 'fr-alert', 'fr-alert--info']): HTMLDivElement => {
    const conteneur = document.createElement('div')
    conteneur.classList.add(...classes)
    conteneur.innerHTML = texte
    const spinner = createSpinner()
    conteneur.append(spinner)
    return conteneur
}

export const removeLoader = (): void => {
    const loader = $$('.blocs-chargement-spinner')
    if (loader) {
        loader.forEach((element) => {
            element.remove()
        })
    }
}

export const createElement = <K extends keyof HTMLElementTagNameMap>(tag: K, classes?: string[], options?: ElementCreationOptions): HTMLElementTagNameMap[K] => {
    const element = document.createElement<K>(tag, options)
    if (classes) {
        element.classList.add(...classes)
    }
    return element
}

export const createIcon = (icon: string, title: string | null = null, optionnalClasses: string[] = []) => {
    const iconElement = createElement('i', [icon, ...optionnalClasses])
    if (title) iconElement.setAttribute('title', title)
    iconElement.setAttribute('aria-hidden', "true")
    return iconElement
}

export const createSpinner = (size: 'xs' | 'sm' | 'md' | 'lg' = "md", color: string = "inherit") => {
    const element = createElement('i')
    element.classList.add('remix-spinner', size)
    element.style.color = color
    element.setAttribute('aria-hidden', 'true')
    return element
}
export const getParentElementByClassName = (element: HTMLElement | null | undefined, className: string): HTMLElement | null => {
    if (element) {
        if (element.classList.contains(className)) return element
        if (element.parentElement) return getParentElementByClassName(element.parentElement, className)
    }
    return null
}

export const getParentElementByTagName = <K extends keyof HTMLElementTagNameMap>(element: HTMLElement, tagName: K): HTMLElement | null => {
    if (element.tagName.toLowerCase() === tagName.toLowerCase()) return element
    if (element.parentElement) return getParentElementByTagName(element.parentElement, tagName)
    return null
}

export const getParentElementByAttribute = (element: HTMLElement, attribute: string, value: string): HTMLElement | null => {
    if (element.getAttribute(attribute) === value) return element
    if (element.parentElement) return getParentElementByAttribute(element.parentElement, attribute, value)
    return null
}
export const getParentElementWithAttribute = (element: HTMLElement, attribute: string): HTMLElement | null => {
    if (element.hasAttribute(attribute)) return element
    if (element.parentElement) return getParentElementWithAttribute(element.parentElement, attribute)
    return null
}

export const getParentElementById = (element: HTMLElement, id: string): HTMLElement | null => {
    if (element.id === id) return element
    if (element.parentElement) return getParentElementById(element.parentElement, id)
    return null
}

export const removeChildElementByClass = (element: HTMLElement, classeName: string) => {
    const child = $<HTMLElement>(`.${classeName}`, element)
    if (child) {
        fadeOut(child).then(() => {
            child.remove()
        })
    }
}

export const createHelpContextElement = (help: HelpContext) => {
    const icon = createElement('i', ['remix-aide-contextuelle', 'sm'])
    icon.dataset.help = help.name
    return icon
}

export const insertBefore = (parentNode: Element, newNode: Element, referenceNode: Element) => {
    parentNode.insertBefore(newNode, referenceNode);
}


export const initFullscreen = (elementActionner: HTMLElement | null) => {
    if (document.fullscreenEnabled) {
        if(elementActionner) {
            const toggleFullscreen = (event: DOMEvent<HTMLElement>) => {
                const target = getParentElementByTagName(event.target, 'button')!
                const cible = target?.dataset.fullscreen
                const fullscreenElement = $(`#${cible}`)
                if(fullscreenElement) {
                    if (!document.fullscreenElement) {
                        fullscreenElement.requestFullscreen()
                        fullscreenElement.classList.add("fullscreen-scroll")
                        target.innerText = "Quittez le plein écran"
                    } else {
                        fullscreenElement.classList.remove("fullscreen-scroll")
                        document.exitFullscreen()
                        target.innerText = "Plein écran"
                    }
                }
            }

            elementActionner.addEventListener('click', toggleFullscreen)
        }
    } else {
        createErrorNotification({
            message: "Votre navigateur ne supporte pas le plein écran ou vous avez désactivé cette fonctionnalité.",
        })
    }
}

export const createScript = (url: string) => {
    const scriptElement = document.createElement('script')
    scriptElement.setAttribute('src', url)
    document.head.appendChild(scriptElement);
}

/**
 * permet de trier des éléments dans un container
 * @param containerSelector
 * @param elementToSortSelector
 * @param attrToSort
 * @param orderOf
 */

export function domSort(containerSelector: string, elementToSortSelector: string, attrToSort: string, orderOf: string) {
    let container = document.querySelector(containerSelector);
    if (container) {
        let elements = Array.from($$<HTMLElement>(elementToSortSelector, container))
        let sorted = elements.sort((a, b) => {
            if (orderOf === 'asc') {
                return a.dataset[attrToSort]!.localeCompare(b.dataset[attrToSort]!)
            }
            else {
                return b.dataset[attrToSort]!.localeCompare(a.dataset[attrToSort]!)
            }
        })
      container.innerHTML = '';
      sorted.forEach(elm => container?.appendChild(elm))
    }
}

export function scrolltoElement(element: HTMLElement | null | undefined) {
    if(element) {
        element.scrollIntoView({behavior: "smooth"})
        element.focus()
    }
}